// Search overlay: body-level full-screen overlay, ⌘K shortcut, chips, recents
(function () {
  'use strict';

  var RECENT_KEY = 'sr-recent-searches';
  var MAX_RECENT = 5;

  /* ── Body-level overlay open/close ───────────────────────────────── */
  function getOverlay() { return document.getElementById('sr-overlay'); }

  function openOverlay() {
    var overlay = getOverlay();
    if (!overlay) return;
    overlay.style.display = 'flex';
    overlay.classList.add('is-open');
    overlay.removeAttribute('aria-hidden');
    document.body.classList.add('sr-overlay-open');
    renderRecent();
    setTimeout(function () {
      var input = overlay.querySelector('input[type="search"]');
      if (input) input.focus();
    }, 60);
  }

  function closeOverlay() {
    var overlay = getOverlay();
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sr-overlay-open');
    var trigger = document.querySelector('[data-sr-open-overlay]');
    if (trigger) trigger.focus();
    setTimeout(function () {
      if (!overlay.classList.contains('is-open')) overlay.style.display = '';
    }, 260);
  }

  /* Open from trigger (pill / mobile icon) */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sr-open-overlay]');
    if (!trigger) return;
    e.preventDefault();
    openOverlay();
  });

  /* Close from X button, mobile back button, backdrop, or any click outside the card */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sr-close-overlay]')) {
      e.preventDefault();
      closeOverlay();
      return;
    }
    var overlay = getOverlay();
    if (!overlay || !overlay.classList.contains('is-open')) return;
    // Ignore clicks on whatever opened the overlay
    if (e.target.closest('[data-sr-open-overlay]')) return;
    // Close when the click happened outside the card (backdrop or padding area)
    var card = overlay.querySelector('.sr-overlay__card');
    if (card && !card.contains(e.target)) {
      closeOverlay();
    }
  });

  /* Esc key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var overlay = getOverlay();
      if (overlay && overlay.classList.contains('is-open')) closeOverlay();
    }
  });

  /* ⌘K / Ctrl+K shortcut */
  document.addEventListener('keydown', function (e) {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      var overlay = getOverlay();
      if (overlay && overlay.classList.contains('is-open')) closeOverlay();
      else openOverlay();
    }
  });

  /* Clear button - discard only the current draft, keeping the AI thread. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sr-backspace]');
    if (!btn) return;
    e.preventDefault(); // keep Shopify SearchForm from resetting the prefilled page query
    var overlay = getOverlay();
    if (!overlay) return;
    var input = overlay.querySelector('input[type="search"]');
    if (!input) return;
    if (!input.value.length) return;
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    btn.classList.add('hidden');
    input.focus();
  });

  /* ── Chip & recent-item click → fill input ───────────────────────── */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-sr-query]');
    if (!chip) return;

    // Find the search input inside the overlay
    var overlay = getOverlay();
    if (!overlay) return;
    var input = overlay.querySelector('input[type="search"]');
    if (!input) return;

    input.value = chip.dataset.srQuery;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  });

  /* ── Recent searches ─────────────────────────────────────────────── */
  function getRecent() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }

  function saveRecent(term) {
    term = (term || '').trim();
    if (term.length < 2) return;
    var list = getRecent().filter(function (s) { return s !== term; });
    list.unshift(term);
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
    } catch (_) {}
  }

  function renderRecent() {
    var section = document.querySelector('[data-sr-recent]');
    var list = document.querySelector('[data-sr-recent-list]');
    if (!section || !list) return;

    var recent = getRecent();
    if (!recent.length) {
      section.hidden = true;
      return;
    }
    section.hidden = false;

    list.innerHTML = recent.map(function (term) {
      var safe = term.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
      return (
        '<button type="button" class="sr-recent-item" data-sr-query="' + safe + '">' +
          '<span class="sr-recent-item__icon">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' +
              '<circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/>' +
            '</svg>' +
          '</span>' +
          '<span class="sr-recent-item__text">' + safe + '</span>' +
          '<svg class="sr-recent-item__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' +
            '<line x1="7" y1="17" x2="17" y2="7"/><polyline points="7,7 17,7 17,17"/>' +
          '</svg>' +
        '</button>'
      );
    }).join('');
  }

  /* Save on form submit */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('#sr-overlay form');
    if (!form) return;
    var input = form.querySelector('input[type="search"]');
    if (input) saveRecent(input.value);
  });

  /* Save when clicking a predictive result link */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest(
      '#sr-overlay .predictive-search__item a, ' +
      '#sr-overlay .predictive-search__item--term'
    );
    if (!link) return;
    var input = document.querySelector('#sr-overlay input[type="search"]');
    if (input) saveRecent(input.value);
  });

  /* Initial render for pre-populated state */
  renderRecent();

  /* Show/hide backspace button as user types */
  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('#sr-overlay input[type="search"]');
    if (!input) return;
    var btn = document.querySelector('#sr-overlay [data-sr-backspace]');
    if (!btn) return;
    btn.classList.toggle('hidden', !input.value.length);
  });

  /* ── Search results filter / sort dropdowns ──────────────────────── */
  (function() {
    var SORT_OPTIONS = [
      { value: 'relevance', label: 'Relevance' },
      { value: 'price-ascending', label: 'Price: Low to High' },
      { value: 'price-descending', label: 'Price: High to Low' },
      { value: 'title-ascending', label: 'A → Z' },
      { value: 'title-descending', label: 'Z → A' },
      { value: 'created-descending', label: 'Newest' },
      { value: 'best-selling', label: 'Best selling' }
    ];

    var PRICE_OPTIONS = [
      { value: '', label: 'All prices' },
      { value: '0-10', label: 'Under S$10' },
      { value: '10-50', label: 'S$10 – S$50' },
      { value: '50-100', label: 'S$50 – S$100' },
      { value: '100-200', label: 'S$100 – S$200' },
      { value: '200-', label: 'Over S$200' }
    ];

    var AVAILABILITY_OPTIONS = [
      { value: '', label: 'Show all' },
      { value: '1', label: 'In stock only' }
    ];

    function closeAllDropdowns() {
      var existing = document.querySelectorAll('.sr-filter-popover');
      existing.forEach(function(e) { e.remove(); });
    }

    function buildOptionsForType(type, btn) {
      if (type === 'sort') return SORT_OPTIONS;
      if (type === 'price') return PRICE_OPTIONS;
      if (type === 'availability') return AVAILABILITY_OPTIONS;
      if (type === 'category') {
        var raw = btn && btn.getAttribute('data-sr-categories');
        var types = [];
        if (raw) {
          try { types = JSON.parse(raw); } catch (_) { types = []; }
        }
        var opts = [{ value: '', label: 'All categories' }];
        for (var i = 0; i < types.length; i++) {
          if (types[i]) opts.push({ value: types[i], label: types[i] });
        }
        return opts;
      }
      return [];
    }

    function getCurrentValue(type) {
      var url = new URL(window.location.href);
      if (type === 'sort') return url.searchParams.get('sort_by') || 'relevance';
      if (type === 'availability') return url.searchParams.get('filter.v.availability') || '';
      if (type === 'category') return url.searchParams.get('filter.p.product_type') || '';
      if (type === 'price') {
        var gte = url.searchParams.get('filter.v.price.gte') || '';
        var lte = url.searchParams.get('filter.v.price.lte') || '';
        if (!gte && !lte) return '';
        return gte + '-' + lte;
      }
      return '';
    }

    function applyFilter(type, value) {
      var url = new URL(window.location.href);
      if (type === 'sort') {
        if (value && value !== 'relevance') url.searchParams.set('sort_by', value);
        else url.searchParams.delete('sort_by');
      } else if (type === 'availability') {
        if (value) url.searchParams.set('filter.v.availability', value);
        else url.searchParams.delete('filter.v.availability');
      } else if (type === 'category') {
        if (value) url.searchParams.set('filter.p.product_type', value);
        else url.searchParams.delete('filter.p.product_type');
      } else if (type === 'price') {
        url.searchParams.delete('filter.v.price.gte');
        url.searchParams.delete('filter.v.price.lte');
        if (value) {
          var parts = value.split('-');
          if (parts[0]) url.searchParams.set('filter.v.price.gte', parts[0]);
          if (parts[1]) url.searchParams.set('filter.v.price.lte', parts[1]);
        }
      }
      window.location.href = url.toString();
    }

    function openDropdown(btn) {
      var type = btn.getAttribute('data-sr-filter');
      if (!type || type === 'sort' && false) {} // placeholder

      closeAllDropdowns();

      var options = buildOptionsForType(type, btn);
      if (!options.length) return;

      var current = getCurrentValue(type);
      var rect = btn.getBoundingClientRect();
      var pop = document.createElement('div');
      pop.className = 'sr-filter-popover';
      pop.setAttribute('role', 'listbox');
      pop.style.cssText = [
        'position: fixed',
        'top: ' + (rect.bottom + 6) + 'px',
        'left: ' + rect.left + 'px',
        'z-index: 10000',
        'background: #fff',
        'border: 1px solid #ECECE8',
        'border-radius: 12px',
        'box-shadow: 0 12px 32px rgba(10,10,10,0.10), 0 2px 6px rgba(10,10,10,0.05)',
        'padding: 6px',
        'min-width: ' + Math.max(rect.width, 200) + 'px',
        'max-height: 320px',
        'overflow-y: auto',
        'font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Inter, system-ui, sans-serif'
      ].join('; ');

      options.forEach(function(opt) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'sr-filter-popover__item';
        item.setAttribute('role', 'option');
        item.setAttribute('data-sr-option', opt.value);
        var isActive = opt.value === current;
        item.style.cssText = [
          'display: flex',
          'align-items: center',
          'justify-content: space-between',
          'width: 100%',
          'padding: 10px 12px',
          'border-radius: 8px',
          'border: 0',
          'background: ' + (isActive ? '#F5F5F1' : 'transparent'),
          'cursor: pointer',
          'font-size: 13px',
          'font-weight: ' + (isActive ? '600' : '500'),
          'color: #0A0A0A',
          'text-align: left',
          'gap: 8px'
        ].join('; ');
        item.innerHTML = '<span>' + opt.label + '</span>' +
          (isActive ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' : '');
        item.addEventListener('mouseenter', function() {
          if (!isActive) item.style.background = '#F5F5F1';
        });
        item.addEventListener('mouseleave', function() {
          if (!isActive) item.style.background = 'transparent';
        });
        item.addEventListener('click', function(e) {
          e.stopPropagation();
          applyFilter(type, opt.value);
        });
        pop.appendChild(item);
      });

      document.body.appendChild(pop);

      // Close on outside click
      setTimeout(function() {
        function onDocClick(e) {
          if (!pop.contains(e.target) && e.target !== btn && !btn.contains(e.target)) {
            pop.remove();
            document.removeEventListener('click', onDocClick);
            document.removeEventListener('keydown', onEsc);
          }
        }
        function onEsc(e) {
          if (e.key === 'Escape') {
            pop.remove();
            document.removeEventListener('click', onDocClick);
            document.removeEventListener('keydown', onEsc);
          }
        }
        document.addEventListener('click', onDocClick);
        document.addEventListener('keydown', onEsc);
      }, 0);
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-sr-filter]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      openDropdown(btn);
    });

    // Close popovers on scroll
    window.addEventListener('scroll', closeAllDropdowns, { passive: true });
  })();
})();
